import gql from 'graphql-tag';

export interface GqlDepartment {
  id: string;
  name: string;
}

export interface GqlJob {
  id: string;
  description: string;
  outlets: any[];
}

export const getDepartment = gql`
  query($level: Int!) {
    departments: listCategory(level: $level) {
      id
      name
    }
  }
`;

export const getJob = gql`
  query($date: String) {
    job: listJobByDate(date: $date) {
      id
      description
      outlets {
        id
        name
      }
    }
  }
`;
